import { Injectable } from '@angular/core';
import { FormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { getDefaultControlValue } from '@gk/gk-modules';
import { MCGRNewRequestSettlementScopeControlName } from '../costs-section/costs-section-form.model';
import {
  MCGRFinancialSectorApplicationFormGroup,
  MCGRNewRequestFinancialSectorApplicationControlName,
} from './financial-sector-application-form-array.model';

@Injectable({
  providedIn: 'root',
})
export class MCGRFinancialSectorApplicationFormArrayService {
  constructor(private formBuilder: UntypedFormBuilder) {}

  getFormGroup(): FormGroup<MCGRFinancialSectorApplicationFormGroup> {
    return this.formBuilder.group({
      [MCGRNewRequestFinancialSectorApplicationControlName.Unit]:
        this.formBuilder.control(getDefaultControlValue(), [
          Validators.required,
        ]),
      [MCGRNewRequestSettlementScopeControlName.Scope]:
        this.formBuilder.control(getDefaultControlValue(), [
          Validators.required,
        ]),
      [MCGRNewRequestSettlementScopeControlName.Amount]:
        this.formBuilder.control(getDefaultControlValue(), [
          Validators.required,
        ]),
      [MCGRNewRequestSettlementScopeControlName.PercentageShare]:
        this.formBuilder.control(getDefaultControlValue(), [
          Validators.required,
        ]),
    });
  }
}
